/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Footer_ToolsInputs */

const en_control_footer_tools = /** @type {(inputs: Control_Footer_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools`)
};

const zh_control_footer_tools = /** @type {(inputs: Control_Footer_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具`)
};

/**
* | output |
* | --- |
* | "Tools" |
*
* @param {Control_Footer_ToolsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_footer_tools = /** @type {((inputs?: Control_Footer_ToolsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Footer_ToolsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_footer_tools(inputs)
	return zh_control_footer_tools(inputs)
});
export { control_footer_tools as "control.footer.tools" }